import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import '../../styles/HomePage/home.css';
import { FaArrowRight } from 'react-icons/fa';
import bgvideo from "../../assets/video1.mp4"

function Home() {

  return (
    <div className="home-container">
      {/* Background Video */}
      <video autoPlay loop muted playsInline className="background-video">
        <source src={bgvideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="video-overlay"></div>

      <div className="bottom-view">
        <Link to="/services" className="view left-view">
          <h2 className="view-title">Our Services</h2>
          <p className="view-text">Deliver Exceptional <br/> Solutions</p>
          <FaArrowRight className="arrow-icon" />
        </Link>

        <Link to="/jobs" className="view right-view"> 
          <h2 className="view-title">For Job Seeker</h2>
          <p className="view-text">Find Your <br/>Dream Job</p>
          <FaArrowRight className="arrow-icon" />
        </Link>
      </div>
    </div>
  );
}

export default Home;
